var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** sys: begin */
export * from '../bean/sys.icon.js';
import 'zova';
/** sys: end */
/** sys: begin */
import { SysIcon } from '../bean/sys.icon.js';
import 'zova';
/** sys: end */
/** tool: begin */
export * from '../bean/tool.icon.js';
import 'zova';
/** tool: end */
/** tool: begin */
import { ToolIcon } from '../bean/tool.icon.js';
import 'zova';
/** tool: end */
/** controller: begin */
export * from '../component/icon/controller.jsx';
import 'zova';
/** controller: end */
/** controller: begin */
import { ControllerIcon } from '../component/icon/controller.jsx';
import 'zova';
/** controller: end */

/** components: begin */
export * from './component/icon.js';
import { ZIcon } from './component/icon.js';
export const components = {
  'icon': ZIcon
};
import 'zova';
/** components: end */
/** config: begin */
export * from '../config/config.js';
/** config: end */
/** monkeySys: begin */
export * from '../monkeySys.js';
/** monkeySys: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleAIcon = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-icon"
}), _dec(_class = _dec2(_class = class ScopeModuleAIcon extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */